import { useEffect, useState } from "react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import Typography from "@/components/ui/typography";
import { cn } from "@/lib/utils";

import { ChartRenderer } from "./ChartRenderer";
import { ChartProps } from "./ChartTypes";

const Chart = ({
  title,
  type,
  data,
  categories,
  // Default to SDS palette: purple, blue, green, yellow, red
  colors = ["#4f55e8", "#5ccedf", "#83b300", "#f1d545", "#f56060"],
  height = 300,
  showLegend = true,
  isLoading = false,
  className,
  hideGrid = false,
  formatYAxis = false,
}: ChartProps) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return (
    <Card
      className={cn(
        "overflow-hidden transition-all duration-300 hover:shadow-md",
        className,
      )}
    >
      <CardHeader>
        <CardTitle>
          <Typography size="sh1" as="span" className="text-[#1e1e24]">
            {title}
          </Typography>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6 pt-0">
        {isLoading ? (
          <div className="flex flex-col space-y-3">
            <Skeleton className="h-[250px] w-full" />
            <div className="flex justify-between">
              {[...Array(4)].map((_, index) => (
                <Skeleton key={index} className="h-4 w-14" />
              ))}
            </div>
          </div>
        ) : (
          <div className="w-full mt-2">
            {isClient && (
              <ChartRenderer
                type={type}
                data={data}
                categories={categories}
                colors={colors}
                height={height}
                showLegend={showLegend}
                hideGrid={hideGrid}
                formatYAxis={formatYAxis}
              />
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
export default Chart;
